import { Component, Input, OnInit, ViewChild, inject } from "@angular/core";
import { AuditService } from "@app/services/http/audit.service";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { BaseAuditRenderer } from "@app/view/shared/audits/base/base-audit-renderer";
import { GridComponent as GridComponent_1 } from "../../base-pages/base-data-table-page/grid.component";

@Component({
  selector: "scheduler-resource-availability-audit-renderer",
  templateUrl: "./resource-availability-audit-renderer.component.html",
  styleUrls: ["./resource-availability-audit-renderer.component.css"],
  imports: [GridComponent_1]
})
export class ResourceAvailabilityAuditRendererComponent
  extends BaseAuditRenderer
  implements OnInit
{
  auditService: AuditService;

  @Input() availabilityId: string;
  @Input() snapshotId: string;
  /*
   resource: ResourceModel;
  start: Date;
  end: Date;
  availabilityCode: AvailabilityCode;
  description: string;
  autoGenerated: boolean;
  cyclicalPriorityReservationDuration: number;
  cyclicalPriorityReservationPercent: number;
  normalPriorityReservationDuration: number;
  normalPriorityReservationPercent: number;
  highPriorityReservationDuration: number;
  highPriorityReservationPercent: number;
  emergencyPriorityReservationDuration: number;
  emergencyPriorityReservationPercent: number;
  location: LocationModel;
  */
  displayedValues = [
    "resource",
    "start",
    "end",
    "availabilityCode",
    "description",
    "autoGenerated",
    "cyclicalPriorityReservationPercent",
    "normalPriorityReservationPercent",
    "highPriorityReservationPercent",
    "emergencyPriorityReservationPercent",
    "location"
  ];
  @ViewChild(GridComponent, { static: true }) auditGrid: GridComponent;

  constructor() {
    const auditService = inject(AuditService);

    super(auditService, "resourceAvailability");

    this.auditService = auditService;
  }

  ngOnInit() {
    this.getAudit(
      this.snapshotId,
      this.availabilityId,
      this.auditGrid,
      this.displayedValues
    );
  }
}
